import { postP,get,getJ,put,deleteP,getExcel,uploadOther,uploadOtherSort,upload,postOther,postPackage,getPDF,deletes,importExcel,createPDF } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    // 创建后台用户
    CreateUser(datas){
        return postP('Admin/CreateUser',datas)
    },
    // 修改后台用户
    UpdateUser(datas){
        return postP('Admin/UpdateUser',datas)
    },
    // 查询后台用户
    QueryUsers(datas){
        return postP('Admin/QuryUsers',datas)
    },

        // 查询后台用户
        QueryUsersList(datas){
            return postP('Admin/QuryUsersList',datas)
        },
    
    

    // 获取角色列表
    QueryRole(datas){
        return get('Admin/QueryRole',datas)
    },
    // 更新角色
    UpdateRole(datas){
        return postP('Admin/UpdateRole',datas)
    },
    // 删除角色
    DeleteRole(datas){
        return deleteP('Admin/DeleteRole',datas)
    },
    // 创建后台用户角色
    CreateRole(datas){
        return postP('Admin/CreateRole',datas)
    },

    // 创建作业机构
    CreateMechanism(datas){
        return postP('Admin/CreateMechanism',datas)
    },
    // 修改作业机构
    UpdateMechanism(datas){
        return put('Admin/UpdateMechanism',datas)
    },
    // 删除作业机构
    deleteMechanism(datas){
        return deleteP('Admin/DeleteMechanism',datas)
    },
    // 作业机构列表
    QueryMechanism(datas){
        return get('Admin/QueryMechanism',datas)
    },
    // 作业机构详情
    QuryMechanismById(datas){
        return get('Admin/QuryMechanismById/'+datas)
    },

    //事业部列表
    QueryCauseList(datas){
        return get('Admin/QueryPagerAsync',datas)
    },
    //事业部详情
    QueryCauseById(datas){
        return get('Admin/QuryByIdAsync/'+datas)
    },
    // 修改事业部
    UpdateCause(datas){
        return put('Admin/UpdateAsync',datas)
    },
    // 创建事业部
    CreateCause(datas){
        return postP('Admin/CreateAsync',datas)
    },
    // 删除事业部
    DeleteCause(datas){
        return deleteP('Admin/DeleteAsync',datas)
    },

    
    

    //创建后台资源
    createResource(datas){
        return postP('Admin/CreateResource',datas)
    },
    //删除资源
    deleteResource(datas){
        return deleteP('Admin/DeleteResource',datas)
    },
    //获取所有菜单资源
    queryResource(datas){
        return get('Admin/QueryResource',datas)
    },
    //修改权限
    updateResource(datas){
        return postP('Admin/UpdateResource',datas)
    },
    

    // 创建角色菜单
    createPermission(datas){
        return postP('Admin/CreatePermission',datas)
    },
    // 修改角色菜单
    updatePermission(datas){
        return postP('Admin/UpdatePermission',datas)
    },
    // 根据角色查询权限
    queryRoleResource(datas){
        return get('Admin/queryPermission/'+datas)
    },
    // 根据机构查询人员列表
    queryUserByMechanismId(datas){
        return get('Admin/QueryUserByMechanismId/'+datas)
    },

    // 总部角标
    MessageNum(datas){
        return get('MessageNum/MessageNum',datas)
    },
    

    // 填写调查结论，意见，减损——总、人员
    UpdateCccnn(datas){
        return postP('AnXinDcTask/UpdateJlyjjsjp',datas)
    },
    // 提交调查任务到安心——总部
    doubtTaskComplete(datas){
        return postP('AnXinDcTask/DoubtTaskComplete',datas)
    },
    
    // 查询任务列表——总
    queryPagerAnXinDcTask(datas){
        return get('AnXinDcTask/queryPagerAnXinDcTask',datas)
    },
    // 查询任务详情——总
    queryAnXinDcTaskByAnXinDcTaskId(datas){
        return get('AnXinDcTask/QueryAnXinDcTaskByAnXinDcTaskId/'+datas)
    },
    // 总部查询资料——总
    queryAnXinCaseMaterialItemByAnXinDcTaskId(datas){
        return get('AnXinDcTask/QueryAnXinCaseMaterialItemByAnXinDcTaskId/'+datas)
    },
    // 总部查询调查信息——总
    queryAnXinDoubtDetailByAnXinDcTaskId(datas){
        return get('AnXinDcTask/QueryAnXinDoubtDetailByAnXinDcTaskId/'+datas)
    },
    // 总部接受任务——总
    receiveAnXinDcTask(datas){
        return postP('AnXinDcTask/ReceiveAnXinDcTask',datas)
    },
    // 拒绝调查——总
    backForUpdate(datas){
        return postP('AnXinDcTask/BackForUpdate',datas)
    },
    // 查询任务列表——总
    queryPagerAnXinDcTaskAudit(datas){
        return get('DoubtTask/QueryPagerDoubtTask',datas)
    },
    updateExecuteActionDoubtTask(datas){
        return postP('DoubtTask/UpdateExecuteAction',datas)
    },
    // 添加调查资料——总
    addAnXinCaseMaterialItem(datas){
        return postP('AnXinDcTask/AddAnXinCaseMaterialItem',datas)
    },
    // 批量派分任务到作业机构——总
    batchDispatchTaskToOperatorMechanism(datas){
        return postP('DoubtTask/BatchDispatchTaskToOperatorMechanism',datas)
    },
    // 取消指派作业机构——总
    canceDispatchTaskToOperatorMechanism(datas){
        return postP('DoubtTask/CanceDispatchTaskToOperatorMechanism',datas)
    },
    // 设为主派机构——总
    setZhuPaiMechanism(datas){
        return postP('DoubtTask/SetZhuPaiMechanism',datas)
    },
    
    // 通过调查任务Id查询任务列表——总
    queryDoubtTasksByAnXinDcTaskId(datas){
        return get('DoubtTask/QueryDoubtTasksByAnXinDcTaskId/'+datas)
    },
    // 通过安心调查任务Id查询日志——总
    queryAnXinOperationLogByAnXinDcTaskId(datas){
        return get('AnXinDcTask/QueryOperationLogByAnXinDcTaskId/'+datas)
    },
    // 总部查询调查过程和调查资料——总
    queryDoubtTaskItemByAnXinDcTaskId(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemByAnXinDcTaskId/'+datas)
    },
    // 总部查询人员提交过来的——总
    queryPagerDoubtTaskItem(datas){
        return get('DoubtTaskItem/QueryPagerDoubtTaskItem',datas)
    },
    // 总部编辑调查过程——总
    updateDoubtCourseList(datas){
        return put('DoubtTaskItem/UpdateDoubtCourseList',datas)
    },
    // 总部删除调查过程——总
    deleteDoubtCourseList(datas){
        return deletes('DoubtTaskItem/DeleteDoubtCourseList',datas)
    },
    // 根据机构任务ID查询人员——总
    queryOperatorByDoubtTaskId(datas){
        return get('DoubtTaskItem/QueryOperatorByDoubtTaskId/'+datas)
    },
    // 新增过程——总
    addDoubtCourseList(datas){
        return postP('DoubtTaskItem/AddDoubtCourseList/',datas)
    },
    // 新增资料——总
    addDoubTaskMaterialItems(datas){
        return postP('DoubtTaskItem/AddDoubTaskMaterialItems/',datas)
    },
    // 删除资料——总
    deleteDoubTaskMaterialItems(datas){
        return deletes('DoubtTaskItem/DeleteDoubtMaterialItems/',datas)
    },
    // 审核退回——总
    anXinDcTaskReturnTask(datas){
        return postP('AnXinDcTask/ReturnTask',datas)
    },
    // 保司审核退回——总
    anXinDcTaskBSReturnTask(datas){
        return postP('AnXinDcTask/BsReturnTask',datas)
    },
    // 查询调查员上传的所有资料——总
    queryDoubtTaskItemMaterialItemByAnXinDcTaskId(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemMaterialItemByAnXinDcTaskId/'+datas)
    },
    // 资料排序——总
    sortDoubTaskMaterialItem(datas){
        return put('DoubtTaskItem/SortDoubTaskMaterialItem',datas)
    },
    // 通过调查任务ID查询作业人员相关信息——总
    querayDcTaskOperatorByAnXinDcTaskId(datas){
        return get('DoubtTaskItem/QuerayDcTaskOperatorByAnXinDcTaskId/'+datas)
    },
    // 编辑调查资料分类名称——总
    updateDoubTaskMaterialItemName(datas){
        return postP('DoubtTaskItem/UpdateDoubTaskMaterialItemName',datas)
    },
    // 新增调查资料——总
    addDoubTaskMaterialItemName(datas){
        return postP('DoubtTaskItem/AddDoubTaskMaterialItemName',datas)
    },
    // 财务日志——总
    queryAnXinFinanceLogByAnXinDcTaskId(datas){
        return get('AnXinDcTask/QueryAnXinFinanceLogByAnXinDcTaskId/'+datas)
    },

    // 更改调查任务状态——总
    anXinDcTaskUpdateDcTaskAction(datas){
        return postP('AnXinDcTask/UpdateDcTaskAction',datas)
    },
    anXinDcTaskReturnTask(datas){
        return postP('AnXinDcTask/ReturnTask',datas)
    },
    //再次推送
    anXinDcTaskSendDcTaskAction(datas){
        return postP('AnXinDcTask/SendCwDcTaskAction',datas)
    },

    // 机构接受任务——机构
    receiveDoubtTask(datas){
        return postP('DoubtTask/ReceiveDoubtTask',datas)
    },
    // 展业机构查询——机构
    queryPagerZyAnXinDcTask(datas){
        return get('AnXinDcTask/QueryPagerZyAnXinDcTask',datas)
    },
    QueryPageInsupDcTask(datas){
        return get('AnXinDcTask/QueryPageInsupDcTask',datas)
    },
    QueryPageInsupAdminDcTask(datas){
        return get('AnXinDcTask/QueryPageInsupAdminDcTask',datas)
    },
    // 机构查看任务详情——机构
    queryDoubtTaskById(datas){
        return get('DoubtTask/queryDoubtTaskById/'+datas)
    },
    // 通过调查任务Id查询其他任务列表——机构
    queryOtherDoubtTasksByanXinDcTaskId(datas){
        return get('DoubtTask/QueryOtherDoubtTasksByAnXinDcTaskId/'+datas)
    },
    // 机构查询任务列表——机构
    queryPagerJgDoubtTask(datas){
        return get('DoubtTask/QueryPagerJgDoubtTask',datas)
    },
    // 机构分配任务给调查员——机构
    assignTaskToOperator(datas){
        return postP('DoubtTaskItem/AssignTaskToOperator',datas)
    },
    // 设置主派调查员——机构
    setZhuPaiOperator(datas){
        return postP('DoubtTaskItem/SetZhuPaiOperator',datas)
    },
    // 机构任务详情查询人员任务——机构
    queryDoubtTaskItemByDoubtTaskId(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemByDoubtTaskId/'+datas)
    },
    // 查询机构调查信息——机构
    queryDoubtTaskItemByDoubtTaskIdd(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemByDoubtTaskIdd/'+datas)
    },
    // 查询机构任务日志——机构
    queryAnXinOperationLogByDoubtTaskId(datas){
        return get('DoubtTask/QueryAnXinOperationLogByDoubtTaskId/'+datas)
    },
    // /api/AnXinDcTask/QueryOperationLogByAnXinDcTaskId/{id}
    // 机构取消指派人员——机构
    deleteDoubtTaskItem(datas){
        return postP('DoubtTaskItem/DeleteDoubtTaskItem/'+datas)
    },
    // 机构查询待审核任务——机构
    queryJgDoubtTaskItem(datas){
        return get('DoubtTaskItem/QueryJgDoubtTaskItem',datas)
    },
    // 更新任务审核状态——机构
    updateAuditStatusDoubtTask(datas){
        return postP('DoubtTask/UpdateAuditStatus',datas)
    },
    doubtTaskReturnTask(datas){
        return postP('DoubtTask/ReturnTask',datas)
    },
    // 判断是否是主派机构或者主派人员——机构
    checkZp(datas){
        return get('DoubtTask/CheckZp',datas)
    },
    // 机构查询资料列表——机构
    queryDoubtTaskItemMaterialItemByDoubTaskId(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemMaterialItemByDoubTaskId/'+datas)
    },

    // 人员接收任务——人员
    receiveDoubtTaskItem(datas){
        return postP('DoubtTaskItem/ReceiveDoubtTaskItem',datas)
    },
    // 任务列表——人员
    queryDcDoubtTaskItem(datas){
        return get('DoubtTaskItem/QueryDcDoubtTaskItem',datas)
    },
    // 人员任务详情——人员
    queryDoubtTaskItemById(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemById/'+datas)
    },
    // 查询其他人员——人员
    queryOtherDoubtTaskItemByDoubtTaskId(datas){
        return get('DoubtTaskItem/QueryOtherDoubtTaskItemByDoubtTaskId/'+datas)
    },
    queryDoubtTaskItemByAnXinDcTaskIdd(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemByAnXinDcTaskIdd/'+datas)
    },
    // 编辑人员任务——人员
    updateDoubtTaskItem(datas){
        return postP('DoubtTaskItem/UpdateDoubtTaskItem',datas)
    },
    // // 修改任务审核状态——人员
    // updateAuditStatus(datas){
    //     return postP('DoubtTaskItem/UpdateAuditStatus',datas)
    // },
    // 提交任务审核——人员
    updateExecuteAction(datas){
        return postP('DoubtTaskItem/UpdateExecuteAction',datas)
    },


    // 根据人员id查询
    doubtCourseQueryByDoubtTaskItemId(datas){
        return get('DoubtCourse/QueryByDoubtTaskItemId/'+datas)
    },
    // 根据案件id查询
    doubtCourseQueryByAnXinDcTaskId(datas){
        return get('DoubtCourse/QueryByAnXinDcTaskId/'+datas)
    },
    // 根据调查过程id过程详情
    doubtCourseQueryByDoubtCourseId(datas){
        return get('DoubtCourse/QueryByDoubtCourseId/'+datas)
    },
    // 新增调查过程
    doubtCourseAddRange(datas){
        return postP('DoubtCourse/AddRange',datas)
    },
    // 更新调查过程
    doubtCourseUpdate(datas){
        return put('DoubtCourse/Update',datas)
    },
    // 删除调查过程
    doubtCourseDelete(datas){
        return deleteP('DoubtCourse/Delete',datas)
    },

    // 新增调查过程的资料
    addDoubTaskMaterialRange(datas){
        return postP('DoubtCourse/addDoubTaskMaterialRange',datas)
    },
    // 删除调查过程的资料
    deleteDoubTaskMaterial(datas){
        return deleteP('DoubtCourse/DeleteDoubTaskMaterial',datas)
    },
    // 根据调查过程id查询资料
    doubtCourseQueryMaterByDoubtCourseId(datas){
        return get('DoubtCourse/QueryMaterByDoubtCourseId/'+datas)
    },
    // 删除资料
    deleteDoubTaskMaterialByDoubtCourseId_name(datas){
        return deletes('DoubtCourse/DeleteDoubTaskMaterialByDoubtCourseId_name',datas)
    },

    // 查询所有人员的调查过程
    queryDoubtTaskItem_CourseByAnXinDcTaskId(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItem_CourseByAnXinDcTaskId/'+datas)
    },
    // 编辑资料名称
    updateMaterialNameByDoubtCourseId(datas){
        return put('DoubtCourse/UpdateMaterialNameByDoubtCourseId',datas)
    },
    // 资料排序
    SortDoubTaskMaterial(datas){
        return postP('DoubtCourse/SortDoubTaskMaterial',datas)
    },
    // 查询机构和总部的调查过程
    queryByAnXinDcTaskIdExcludeDoubtTaskItem(datas){
        return get('DoubtCourse/QueryByAnXinDcTaskIdExcludeDoubtTaskItem/'+datas)
    },


    // 根据案件id查询调查员
    queryDoubtTaskItemByAnXinDcTaskId(datas){
        return get('DoubtTaskItem/QueryDoubtTaskItemByAnXinDcTaskId/'+datas)
    },

    returnDoubtTaskItem(datas){
        return postP('DoubtTaskItem/ReturnDoubtTaskItem',datas)
    },

    // 查询安心案件详情
    queryPagerAnXinCaseById(datas){
        return get('AnXin/QueryAnXinCaseById/'+datas)
    },
    // 查询安心案件列表
    queryPagerAnXinCase(datas){
        return get('AnXin/QueryPagerAnXinCase',datas)
    },
    // 通过安心案件Id查询安心调查任务
    queryAnXinDcTaskByAnXinCaseId(datas){
        return get('AnXin/QueryAnXinDcTaskByAnXinCaseId/'+datas)
    },
    
    
    // 通过安心案件Id查询日志
    queryAnXinOperationLogByAnXinCaseId(datas){
        return get('AnXin/QueryAnXinOperationLogByAnXinCaseId/'+datas)
    },
    
    // 查询安心案件列表
    queryPagerAnXinCase(datas){
        return get('AnXin/QueryPagerAnXinCase',datas)
    },
    // 派分任务到作业机构
    dispatchTaskToOperatorMechanism(datas){
        return postP('AnXin/DispatchTaskToOperatorMechanism',datas)
    },

    // 查询调查分配任务列表
    queryPagerAnXinDcTask(datas){
        return get('AnXinDcTask/QueryPagerAnXinDcTask',datas)
    },
    // 查询展业机构列表
    queryPagerZyAnXinDcTask(datas){
        return get('AnXinDcTask/QueryPagerZyAnXinDcTask',datas)
    },
    
    
    

    // 安心案件查询日志
    queryAnXinOperationLogByAnXinCaseId(datas){
        return get('AnXin/QueryAnXinOperationLogByAnXinCaseId/'+datas)
    },

    
    
    
    // 调查分配任务列表
    queryDoubtTask(datas){
        return get('AnXin/QueryDoubtTask',datas)
    },
    // 更新作业信息
    updateTask(datas){
        return put('AnXin/UpdateTask',datas)
    },
    // 更新调查信息
    updateTaskInfo(datas){
        return put('AnXin/UpdateTaskInfo',datas)
    },
    // 删除派分任务
    deleteTask(datas){
        return deleteP('AnXin/DeleteTask',datas)
    },
    
    // 调查员查询任务
    queryDcDoubtTask(datas){
        return get('AnXin/QueryDcDoubtTask',datas)
    },
    
      // 调查员查询任务
      addloginfos(datas){
        return postP('AnXinDcTask/CaseLogInsert',datas)
    },
    
    
    
   
    // queryDoubtTaskItem(datas){
    //     return get('AnXin/QueryDoubtTaskItem',datas)
    // },
    
    // // 审核
    // examineTask(datas){
    //     return postP('AnXin/examineTask',datas)
    // },
   
    
    
    // 查询左侧菜单角标
    queryMessageNumResponse(datas){
        return get('AnXin/QueryMessageNumResponse/',datas)
    },

    // 调查员菜单消息角标
    dcMessageNum(datas){
        return get('MessageNum/DcMessageNum/',datas)
    },
    // 机构菜单消息角标
    jgMessageNum(datas){
        return get('MessageNum/JgMessageNum/',datas)
    },
    // 总部菜单消息角标
    zbMessageNum(datas){
        return get('MessageNum/ZbMessageNum/',datas)
    },

    
   
    
    // 人员子任务提交审核
    auditDoubtTask(datas){
        return postP('AnXin/AuditDoubtTask',datas)
    },
    
   
    
    // 查询保险公司列表
    queryCompany(datas){
        return get('Company/PagerQueryCompany',datas)
    },
    queryCompanyPage(datas){
        return get('Company/QueryCompany',datas)
    },
    queryInsuCompanyPage(datas){
        return get('Company/QueryInsuCompany',datas)
    },
    // 添加保险公司
    addCompany(datas){
        return postP('Company/AddAsync',datas)
    },
    // 修改保险公司
    updateCompany(datas){
        return put('Company/UpdateAsync',datas)
    },
    // 删除保险公司
    deleteCompany(datas){
        return deleteP('Company/DeleteAsync',datas)
    },

    

    // 查询保险公司ID查询险种列表
    queryCompanyProduct(datas){
        return get('Company/PagerQueryCompanyProduct/'+datas)
    },
    // 修改保险公司险种
    updateCompanyProduct(datas){
        return put('Company/UpdateProductAsync',datas)
    },
    // 删除保险公司险种
    deleteCompanyProduct(datas){
        return put('Company/DeleteProductAsync/'+datas)
    },
    // 添加保险公司险种
    addCompanyProduct(datas){
        return postP('Company/AddProductAsync',datas)
    },

    // 创建作业机构
    CreateMechanism(datas){
        return postP('Admin/CreateMechanism',datas)
    },
    // 修改作业机构
    UpdateMechanism(datas){
        return put('Admin/UpdateMechanism',datas)
    },
    // 作业机构列表
    QueryMechanism(datas){
        return get('Admin/QueryMechanism',datas)
    },
   
    // 删除作业机构
    deleteMechanism(datas){
        return deleteP('Admin/DeleteMechanism',datas)
    },
    queryUserByMechanismIds(datas){
        return get('Admin/QueryUserByMechanismIds',datas)
    },
    
    

    

    // 总部填写调查结论，意见，减损
    ZbUpdateCccnn(datas){
        return put('AnXin/ZbUpdateCccnn',datas)
    },

    
    
    // 机构查询子任务是否完成
    queryDoubtTaskItemByDoubtTaskId_State(datas){
        return get('AnXin/QueryDoubtTaskItemByDoubtTaskId_State/'+datas)
    },

    // 修改密码
    updatePassword(datas){
        return put('OAuth/UpdatePassword',datas)
    },
    
    // 上传表单
    uploadFile(datas){
        return postP('AnXin/UploadFile',datas)
    },
    anXinDcTaskUploadFile(datas){
        return postP('AnXinDcTask/UploadFile',datas)
    },
    // 新增案件
    addAnXinDcTask(datas){
        return postP('AnXinDcTask/AddAnXinDcTask',datas)
    },
       // 新增案件-保司
    addInsupDcTask(datas){
        return postP('AnXinDcTask/AddInsuDcTask',datas)
    },
    // 新增相互宝案件
    addXHBDcTask(datas){
        return postP('AnXinDcTask/AddXHBDcTask',datas)
    },
    updateAnXinDcTask(datas){
        return put('AnXinDcTask/UpdateAnXinDcTask',datas)
    },
    
    restartUploadDoubTaskMaterialItem(datas){
        return postP('DoubtTaskItem/RestartUploadDoubTaskMaterialItem',datas)
    },
    // 上传调查报告
    uploadDcTaskReport(datas){
        return postP('AnXinDcTask/UploadDcTaskReport',datas)
    },
    uploadDcTaskPdf(datas){
        return postP('AnXinDcTask/UploadDcTaskPdf',datas)
    },

    setDcTaskAppraisal(datas){
        return postP('AnXinDcTask/SetDcTaskAppraisal',datas)
    },

    
    imgToPdf(datas,name){
        return postOther('ImgTOPDF/Img',datas,name)
    },
    
    uploadOther(file,params){
        return uploadOther('',file,params)
    },
    
    downFileAnXinDcTask(data,param){
        return postPackage('Common/DownFileAnXinDcTask/'+data,param)
    },

    downFileAnXinPgDcTask(data,param){
        return postPackage('Common/DownFileAnXinPgDcTask/'+data,param)
    },

    downFileDoubtCourse(data,param){
        return postPackage('Common/DownFileDoubtCourse/'+data,param)
    },

    getAccident(datas){
        return createPDF('Accident/Generate',datas)
    },
    getAccidentPDF(datas,name){
        return getPDF('Accident/Generate',datas,name)
    },
    getAccidentImg(datas,name){
        return getPDF('Accident/Img',datas,name)
    },

    addQuickAsync(datas){
        return postP('AnXinDcTask/AddQuickAsync',datas)
    },

    setDcTaskJpyq(datas){
        return postP('AnXinDcTask/SetDcTaskJpyq',datas)
    },
    updateTaskFee(datas){
        return postP('DoubtTask/UpdateTaskFee',datas)
    },
    queryDataCensusDay(datas){
        return get('DataCensus/QueryDataCensusDay',datas)
    },
    queryDataCensusMonth(datas){
        return get('DataCensus/QueryDataCensusMonth',datas)
    },
    queryDataCensusDcTaskQualityAnXin(datas){
        return get('DataCensus/QueryDataCensusDcTaskQualityAnXin',datas)
    },
    queryDataCensusDcTaskQualityRenBao(datas){
        return get('DataCensus/QueryDataCensusDcTaskQualityRenBao',datas)
    },
    queryDataCensusDayDcTaskQuality(datas){
        return get('DataCensus/QueryDataCensusDayDcTaskQuality',datas)
    },
    exportInventory(datas,name){
        return getExcel('Export/Export',datas,name?name:'案件明细清单')
    },
    exportInventoryMer(datas,name){
        return getExcel('Export/ExportMer',datas,name?name:'案件明细清单')
    },

    // 批量导入公估费记录
    importFreeRecord(file,datas){
        return importExcel('Export/import',file,datas)
    },

    // 
    importBatch(file,datas){
        return importExcel('Export/import',file,datas)
    },

    // 派驻人员
    queryPagerPersonPaiZhu(datas){
        return get('PersonPaiZhu/QueryPager',datas)
    },
    // 派驻人员详情
    queryByIdPersonPaiZhu(datas){
        return get('PersonPaiZhu/QueryById/'+datas)
    },
    // 派驻添加
    addPersonPaiZhu(datas){
        return postP('PersonPaiZhu/Add',datas)
    },
        // 派驻导出
        exportPersonPaiZhu(datas){
            //return postP('PersonPaiZhu/pExcel',datas)

            return getExcel('PersonPaiZhu/pExcel',datas,name?name:'人员派驻人员表')
        },
                // 派驻导出
                exportPersonPaiZhuggf(datas){
                    //return postP('PersonPaiZhu/pExcel',datas)
        
                    return getExcel('PersonPaiZhu/ggfExcel',datas,name?name:'人员派驻公估费记录表')
                },
    // 派驻更新
    updatePersonPaiZhu(datas){
        return put('PersonPaiZhu/Update',datas)
    },
    // 通过id删除
    deletePersonPaiZhu(datas){
        return deleteP('PersonPaiZhu/DeleteById',datas)
    },

    // 人员公估费
    queryPagerPersonFeeRecord(datas){
        return get('PersonFeeRecord/QueryPeger',datas)
    },
    // 新增人员公估费
    addPersonFeeRecord(datas){
        return postP('PersonFeeRecord/Add',datas)
    },
    // 更新人员公估费
    updatePersonFeeRecord(datas){
        return put('PersonFeeRecord/Update',datas)
    },
    // 删除人员公估费
    deletePersonFeeRecord(datas){
        return deleteP('PersonFeeRecord/Delete',datas)
    },
    queryMaterByAnXinDcTaskId(datas){
        return get('DoubtCourse/QueryMaterByAnXinDcTaskId/'+datas)
    },

    updateExecuteActionDoubtTask(datas){
        return postP('DoubtTask/UpdateExecuteAction',datas)
    },
    
    // 多地审核
    excuteExecuteActionDoubtTask(datas){
        return postP('DoubtTask/ExcuteExecuteAction/'+datas)
    },

    queryPermissionMenuOperation(datas){
        return get('Admin/QueryPermissionMenuOperation/'+datas)
    },


    deleteByAnXinDcTaskId(datas){
        return deleteP('AnXinDcTask/DeleteByAnXinDcTaskId',datas)
    },

    // 提交总部审核
    submitForReview(datas){
        return postP('DoubtTask/SubmitForReview',datas)
    },
    // 回销调查任务
    sellBack(datas){
        return postP('DoubtTask/SellBack',datas)
    },


    // 推送到财务中台
    pushAnXinDcTaskFinance(datas){
        return postP('Finance/PushAnXinDcTaskFinance',datas)
    },
    pushAnXinDcTaskFinanceByDoubtTaskId(datas){
        return get('Finance/PushAnXinDcTaskFinanceByDoubtTaskId/'+datas)
    },

    // 通过案件id查询案件类型
    anXinDcTaskQueryCaseTypeByAnXinDcTaskId(datas){
        return get('AnXinDcTask/QueryCaseTypeByAnXinDcTaskId/'+datas)
    },

    // 机构指派
    jgDispatchTaskToOperatorMechanism(datas){
        return postP('DoubtTask/JgDispatchTaskToOperatorMechanism',datas)
    },

    jsDownFileAnXinDcTask(datas){
        return get('Common/JsDownFileAnXinDcTask/'+datas)
    },
    submitZyJgReview(datas){
        return postP('DoubtTask/SubmitZyJgReview',datas)
    },

    collectPetAdd(datas){
        return postP('CollectPet/Add',datas)
    },
    collectPetUpdate(datas){
        return put('CollectPet/Update',datas)
    },
    collectPetDelete(datas){
        return deleteP('CollectPet/Delete',datas)
    },
    collectPetQueryPager(datas){
        return get('CollectPet/QueryPager',datas)
    },
    // uploadOtherSort(file,params){
    //     return uploadOtherSort('',file,params)
    // },
    // upload(file,params){
    //     return upload('Common/UploadFile',file,params)
    // },
}